import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import "leaflet/dist/leaflet.css";
import { store } from "./states/Store.js";
import { loadRuntimeConfig } from "./configs/runtimeConfig";
import "./assets/scss/style.scss";
import "./styles/globals.css";
import "./styles/bsi-dashboard-theme.css";

const container = document.getElementById("root");
const root = createRoot(container);

async function bootstrap() {
  try {
    await loadRuntimeConfig();
  } catch (error) {
    console.error("Unable to load backend runtime configuration.", error);
    root.render(
      <div role="alert">
        Konfigurasi backend gagal dimuat: {error?.message || "kesalahan tidak diketahui"}
      </div>
    );
    return;
  }

  try {
    const { default: App } = await import("./App.jsx");
    root.render(
      <Provider store={store}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </Provider>
    );
  } catch (error) {
    console.error("Unable to load the frontend application.", error);
    root.render(
      <div role="alert">
        Aplikasi gagal dimuat: {error?.message || "kesalahan tidak diketahui"}
      </div>
    );
  }
}

void bootstrap();
